module.exports = __webpack_public_path__ + "static/dhaval-97ba1356a5700281d6676356e9f7332a.jpg";